"use client";

import Link from "next/link";

import { useCurrentLocale, useI18n } from "@/locales/client";
export default function ResourcesMega() {
  const t = useI18n();
  const locale = useCurrentLocale();
  const withLocale = (href: string) => {
    if (!href.startsWith("/")) return href;
    if (href === "/") return `/${locale}`;
    if (href === `/${locale}` || href.startsWith(`/${locale}/`)) return href;
    return `/${locale}${href}`;
  };
  const items = [
    // { href: "/resources", label: "Papers" },
    { href: "/blog", label: t("blog") },
    { href: "/podcast", label: t("podcast") },
    { href: "/roi-calculator", label: t("roi-calculator-menu") },
  ];

  return (
    <div className="bg-[#212121] text-white py-4">
      <div className="flex flex-col gap-3">
        {items.map((it) => (
          <div
            key={it.href}
          >
            <Link
              href={withLocale(it.href)}
              prefetch={false}
              className="text-[16px] font-light font-sans transition-colors hover:text-[#FF8B49] px-6 py-2 block"
            >
              {it.label}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

